// extracted by mini-css-extract-plugin
export default {"wrapper":"Radio_wrapper--HAB","input":"Radio_input--jRI","radio":"Radio_radio--Alp","s":"Radio_s--YJf","m":"Radio_m--tqs","disabled":"Radio_disabled--h5i","label":"Radio_label--foY"};